/* =====================================================================
   Stand 40 — Usability-Schleife (automatisch)
   Sammelt auf jedem Gerät leise, OHNE Namen:
     fehler     — Abstürze, Server-Fehler, fehlgeschlagene Speicherungen, Netzabbrüche
     wut        — 3+ schnelle Tipps auf dieselbe Stelle („passiert nichts?")
     zurueck    — Bildschirm geöffnet und nach < 5 s wieder verlassen (falscher Weg)
     hinundher  — A → B → A → B innerhalb von 40 s (sucht etwas)
     irrweg     — 6+ Bildschirmwechsel in 45 s ohne eine einzige echte Aktion
     hakt       — „Hier hakt's"-Knopf (nur Coaches/Headcoach/Büro), mit Text
   Jede Meldung trägt den Bildschirm, die Rolle und die letzten Schritte (Weg).
   Gesendet wird gebündelt an POST /api/ux (sendBeacon beim Verlassen).
   Nie blockierend: Fehler beim Senden werden still verworfen.
   ===================================================================== */

const VERSION = "40";
const MAX_PUFFER = 60;
const API = (typeof window !== "undefined" && window.MICROSOCCER_API_BASE) || "/api";

let puffer = [];
let kontext = { eventId: null, rolle: null };
let bildschirm = "start";
let seit = Date.now();
let weg = []; // [{ s, t }]
let letzteAktion = Date.now();
let gestartet = false;
let geraet = null;
let gemeldet = new Map(); // Entprellen: gleicher Fingerabdruck max. 1x / 60 s

function geraetId() {
  if (geraet) return geraet;
  try { geraet = window.localStorage.getItem("microsoccer_ux_geraet"); } catch (_) { geraet = null; }
  if (!geraet) {
    geraet = "g" + Math.random().toString(36).slice(2, 10);
    try { window.localStorage.setItem("microsoccer_ux_geraet", geraet); } catch (_) { /* noop */ }
  }
  return geraet;
}
const kurz = (s, n = 300) => String(s == null ? "" : s).replace(/\s+/g, " ").trim().slice(0, n);

export function uxMelde(typ, detail = {}, { sofort = false } = {}) {
  try {
    const fp = typ + "|" + bildschirm + "|" + kurz(detail.text || detail.ziel || detail.url || "", 80);
    const jetzt = Date.now();
    if (typ !== "hakt" && gemeldet.has(fp) && jetzt - gemeldet.get(fp) < 60000) return;
    gemeldet.set(fp, jetzt);
    puffer.push({ t: jetzt, typ, bildschirm, rolle: kontext.rolle || null, eventId: kontext.eventId || null,
      weg: weg.slice(-8).map((w) => w.s), detail, v: VERSION, geraet: geraetId() });
    if (puffer.length > MAX_PUFFER) puffer = puffer.slice(-MAX_PUFFER);
    if (sofort || typ === "fehler" || typ === "hakt") senden();
  } catch (_) { /* nie stören */ }
}

export function uxKontext(k) { kontext = { ...kontext, ...k }; }

/* Bildschirmwechsel — von der App bei jedem sichtbaren Wechsel gemeldet. */
export function uxBildschirm(name) {
  if (!name || name === bildschirm) return;
  const jetzt = Date.now();
  const vorher = bildschirm, dauer = jetzt - seit;
  weg.push({ s: name, t: jetzt });
  if (weg.length > 30) weg = weg.slice(-30);
  // falscher Weg: kurz rein, gleich wieder zurück
  const n = weg.length;
  if (n >= 3 && weg[n - 1].s === weg[n - 3].s && dauer < 5000 && vorher !== "laden") uxMelde("zurueck", { ziel: vorher, ms: dauer });
  // hin und her: A B A B
  if (n >= 4 && weg[n - 1].s === weg[n - 3].s && weg[n - 2].s === weg[n - 4].s && weg[n - 1].s !== weg[n - 2].s && jetzt - weg[n - 4].t < 40000)
    uxMelde("hinundher", { ziel: weg[n - 2].s + " ⇄ " + weg[n - 1].s });
  // Irrweg: viele Wechsel ohne echte Aktion
  const fenster = weg.filter((w) => jetzt - w.t < 45000);
  if (fenster.length >= 6 && letzteAktion < fenster[0].t) { uxMelde("irrweg", { ziel: Array.from(new Set(fenster.map((w) => w.s))).join(" → "), wechsel: fenster.length }); letzteAktion = jetzt; }
  bildschirm = name; seit = jetzt;
}

/* Echte Aktion (Reducer-Aktion) — beendet „Irrweg". */
export function uxAktion() { letzteAktion = Date.now(); }

export function uxWeg() { return weg.slice(-8).map((w) => w.s); }
export function uxAktuellerBildschirm() { return bildschirm; }

function senden() {
  if (!puffer.length) return;
  const daten = puffer; puffer = [];
  const body = JSON.stringify({ meldungen: daten });
  try {
    if (navigator.sendBeacon && document.visibilityState === "hidden") {
      navigator.sendBeacon(API + "/ux", new Blob([body], { type: "application/json" }));
      return;
    }
  } catch (_) { /* weiter mit fetch */ }
  try {
    const h = { "Content-Type": "application/json" };
    if (window.MICROSOCCER_API_TOKEN) h["X-Api-Token"] = window.MICROSOCCER_API_TOKEN;
    roheFetch(API + "/ux", { method: "POST", headers: h, body, keepalive: true }).catch(() => {});
  } catch (_) { /* noop */ }
}

let roheFetch = (...a) => fetch(...a);

/* Wut-Tipps: 3+ Tipps in 1,2 s auf dieselbe Stelle. */
function zielName(el) {
  const k = el && el.closest ? el.closest("button, a, [role=button], input, select, label, [data-ux]") || el : el;
  if (!k) return "?";
  const daten = k.attributes ? Array.from(k.attributes).find((a) => a.name.startsWith("data-") && a.name !== "data-ux") : null;
  const txt = kurz(k.getAttribute && (k.getAttribute("data-ux") || k.getAttribute("aria-label")) || k.innerText || k.value || "", 40);
  return (k.tagName || "").toLowerCase() + (daten ? `[${daten.name}]` : "") + (txt ? ` „${txt}"` : "");
}
let tipps = [];
function aufTipp(e) {
  const jetzt = Date.now();
  const ziel = zielName(e.target);
  tipps = tipps.filter((x) => jetzt - x.t < 1200);
  tipps.push({ t: jetzt, ziel });
  const gleich = tipps.filter((x) => x.ziel === ziel).length;
  if (gleich === 3) uxMelde("wut", { ziel, aktiv: !!(e.target && e.target.closest && e.target.closest("button:not([disabled]), a, input, select")) });
}

export function uxStart() {
  if (gestartet || typeof window === "undefined") return;
  gestartet = true;
  window.addEventListener("error", (e) => {
    uxMelde("fehler", { art: "absturz", text: kurz(e.message || (e.error && e.error.message) || "Fehler"), quelle: kurz((e.filename || "").split("/").pop() + ":" + (e.lineno || ""), 80), stack: kurz(e.error && e.error.stack, 600) });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason || {};
    // erwartete Fälle (Konflikt beim Speichern, Archiv) sind kein Fehler
    if (r && (r.status === 409 || r.status === 423)) return;
    uxMelde("fehler", { art: "promise", text: kurz(r.message || String(r)), stack: kurz(r.stack, 600) });
  });
  // Server-/Netzfehler: fetch einmal umhüllen (nur /api, nie /api/ux selbst)
  try {
    const orig = window.fetch.bind(window);
    roheFetch = orig;
    window.fetch = async (input, init) => {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      const istApi = /\/api\//.test(url) && !/\/api\/ux\b/.test(url);
      const pfad = istApi ? url.replace(/^https?:\/\/[^/]+/, "").replace(/\?.*$/, "").replace(/\/ev[0-9a-z]{6,}/gi, "/:id").replace(/\/e\d+\b/g, "/:id") : "";
      try {
        const res = await orig(input, init);
        if (istApi && (res.status >= 500 || res.status === 400 || res.status === 413 || res.status === 422)) {
          uxMelde("fehler", { art: "server", url: pfad, status: res.status, methode: (init && init.method) || "GET" });
        }
        return res;
      } catch (err) {
        if (istApi && !(err && err.name === "AbortError")) uxMelde("fehler", { art: "netz", url: pfad, text: kurz(err && err.message), online: navigator.onLine !== false });
        throw err;
      }
    };
  } catch (_) { /* noop */ }
  document.addEventListener("click", aufTipp, true);
  setInterval(senden, 15000);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") senden(); });
  window.addEventListener("pagehide", senden);
}

/* Fehler aus der React-Fehlergrenze */
export function uxAbsturz(err, info) {
  uxMelde("fehler", { art: "react", text: kurz(err && err.message), stack: kurz(err && err.stack, 600), komponente: kurz(info && info.componentStack, 400) }, { sofort: true });
}

/* Für Tests */
export function _uxPuffer() { return puffer; }
